/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Notice_PeriodInputs */

const en_admin_resources_notice_period = /** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notice period`)
};

const de_admin_resources_notice_period = /** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigungsfrist`)
};

const es_admin_resources_notice_period = /** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo de aviso`)
};

const fr_admin_resources_notice_period = /** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délai de préavis`)
};

const nl_admin_resources_notice_period = /** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzegtermijn`)
};

/** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */
const it_admin_resources_notice_period = en_admin_resources_notice_period;

/** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */
const pt_br2_admin_resources_notice_period = en_admin_resources_notice_period;

/** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */
const pl_admin_resources_notice_period = en_admin_resources_notice_period;

/** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */
const hu_admin_resources_notice_period = en_admin_resources_notice_period;

/** @type {(inputs: Admin_Resources_Notice_PeriodInputs) => LocalizedString} */
const ro_admin_resources_notice_period = en_admin_resources_notice_period;

/**
* | output |
* | --- |
* | "Notice period" |
*
* @param {Admin_Resources_Notice_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_notice_period = /** @type {((inputs?: Admin_Resources_Notice_PeriodInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Notice_PeriodInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_notice_period(inputs)
	if (locale === "de") return de_admin_resources_notice_period(inputs)
	if (locale === "es") return es_admin_resources_notice_period(inputs)
	if (locale === "fr") return fr_admin_resources_notice_period(inputs)
	if (locale === "nl") return nl_admin_resources_notice_period(inputs)
	if (locale === "it") return it_admin_resources_notice_period(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_notice_period(inputs)
	if (locale === "pl") return pl_admin_resources_notice_period(inputs)
	if (locale === "hu") return hu_admin_resources_notice_period(inputs)
	return ro_admin_resources_notice_period(inputs)
});
export { admin_resources_notice_period as "admin.resources.notice_period" }